export const CLOSE_DIALOG_DELAY = 3000;
export const POLLING_INTERVAL = 1000;
export const POLLING_TIMEOUT = 7000;
export const defaultSelfServeGating = { small: { min: 1, max: 50 } };
